/*
 * Module for the activity feed control
*/

rs.module("ui/controls/content/activity-feed",

    [        
        "controls/components/event-banner",
        "controls/data/grid"
    ],

    function (eventBanner, gridModule) {

        //
        // Initialize
        //
        function initialize(lrsGridApi, jsSelectors, backendUrl, accountPartyKey, ownerKey) {
            var filter = $.js(jsSelectors.filter);
            var milestonesOnlyCheckbox = filter.js(jsSelectors.milestonesOnlyCheckbox);
            var loadingSpinner = filter.js(jsSelectors.loadingSpinner);

            // Hook up click event on the radio buttons to reload the grid data via ajax
            milestonesOnlyCheckbox.on('click', function () {

                loadingSpinner.show();

                // Update grid
                gridModule.update(
                    backendUrl,
                    {
                        accountPartyKey: accountPartyKey,
                        ownerKey: ownerKey,
                        milestonesOnly: milestonesOnlyCheckbox.is(':checked')
                    },
                    lrsGridApi.agGridApi,
                    function done() {
                        loadingSpinner.hide();
                    }
                );
            });

        }

        //
        // Function to execute if an activity feed ajax navigation link cannot be resolved
        //
        function onAjaxNavigationError(errorContext) {

            // Display error message in event banner
            eventBanner.addErrorMessages(errorContext.errorMessage);
        }

        // Exported public API
        var exports = {
            initialize,
            onAjaxNavigationError
        };

        return exports;
    }
);